import React from 'react'
import SuperMarketCommentContainer from '../../../../Components/Comments/SuperMarketCommentContainer/SuperMarketCommentContainer'
import Layout from '../../Layout'

const SuperMarketComment = () => {
  return (
    <Layout>
      <SuperMarketCommentContainer/>
    </Layout>
  )
}

export default SuperMarketComment